import { ApplicationInfo } from './ApplicationInfo';
import { ApplicationVersion } from './ApplicationVersion';
import { ErrorInformationStorage } from './ErrorInformationStorage';
export function CreateApplicationInfo() {
    const elem = document.getElementById('startData');
    if (!elem) {
        return;
    }
    const dt = JSON.parse(elem.innerText);
    try {
        const appVersion = ApplicationVersion.createApplicationVersionByJson(dt.BVD);
        ApplicationInfo.BuildVersionData = appVersion;
    }
    catch (ex) { }
    ApplicationInfo.login_language_selector = dt.lls;
    ApplicationInfo.saveLastLogin = dt.SLL;
    ApplicationInfo.FrequencyLogsSending = dt.FLS;
    ApplicationInfo.ExternalResourse = dt.ER;
    ApplicationInfo.LoginScreenType = dt.LST;
    ApplicationInfo.LoginLanguage = dt.LL;
    ApplicationInfo.LoginToken = dt.LT || null;
    ApplicationInfo.myportfolio = dt.mp || false;
    ErrorInformationStorage.SetTimerValue(ApplicationInfo.FrequencyLogsSending);
    ErrorInformationStorage.SetBuildVersion(ApplicationInfo.BuildVersionData);
    elem.parentElement.removeChild(elem);
}
